$(document).ready(function () {
  var SKELETON_DEBUG = false;
  var skeletonShownAt = null;

  // ── Cart Timing ────────────────────────────────────────────────────────────
  var CART_TIMING_WEBHOOK =
    "https://script.google.com/macros/s/AKfycbxdZDgjb7fFPIsA3Yy_4UEKsX_eW_j9wuV8RANV6XnI1-OV7Ns5VZqkuFVBRByJDcso/exec";

  function getCustomerId() {
    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.customerId
    ) {
      return "shopify_" + window.ShopifyAnalytics.meta.page.customerId;
    }
    var id = localStorage.getItem("_cm_anon_id");
    if (!id) {
      id = "anon_" + Math.random().toString(36).slice(2, 11) + "_" + Date.now();
      localStorage.setItem("_cm_anon_id", id);
    }
    return id;
  }

  function sendCartTiming(clickStart, apiStart, action) {
    if (!CART_TIMING_WEBHOOK || CART_TIMING_WEBHOOK.indexOf("YOUR_") === 0)
      return;
    var now = Date.now();
    fetch(CART_TIMING_WEBHOOK, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: getCustomerId(),
        action: action || "unknown",
        durationSec: Math.round((now - clickStart) / 100) / 10,
        apiDurationSec: Math.round((now - apiStart) / 100) / 10,
        timestamp: new Date().toISOString(),
        page: window.location.pathname,
      }),
    }).catch(function (e) {
      console.warn("Cart timing send failed:", e);
    });
  }
  // ──────────────────────────────────────────────────────────────────────────

  window.openCartDrawer = function (showSkeleton) {
    $(".cd_outer").css("display", "flex");
    $("body, html").addClass("overflow-hidden");
    if (showSkeleton || SKELETON_DEBUG) {
      $(".cd_skeleton").addClass("cd_skeleton--visible");
      skeletonShownAt = Date.now();
    }
    setTimeout(function () {
      $(".cd_outer").addClass("active");
    }, 100);
  };

  window.closeCartDrawer = function () {
    $(".cd_outer").removeClass("active");
    $("body, html").removeClass("overflow-hidden");
    setTimeout(function () {
      $(".cd_outer").hide();
    }, 500);
  };

  window.refreshCartDrawer = function (skipGift, sectionsData) {
    $(".cd_checkoutbnt").addClass("rendering");

    // Capture timing values synchronously and clear globals immediately
    var clickStart = window._cartTimingStart;
    var apiStart = window._cartApiStart;
    var timingAction = window._cartTimingAction;
    window._cartTimingStart = null;
    window._cartApiStart = null;
    window._cartTimingAction = null;

    var $giftData = $(".giftProductData");

    // Always fetch /cart.js — used for header count + gift check
    var cartPromise = fetch("/cart.js").then(function (r) {
      return r.json();
    });

    // If sections were pre-fetched from a cart mutation response, skip the fetch
    var sectionPromise = sectionsData
      ? Promise.resolve(sectionsData)
      : fetch("/?sections=cell_cart_drawer").then(function (r) {
          return r.json();
        });

    sectionPromise.then(function (sections) {
      // Update Cart Drawer Contents
      var cartHtml = sections["cell_cart_drawer"];
      if (cartHtml) {
        var $cartParsed = $("<div>").html(cartHtml);
        var updatedCartDrawer = $cartParsed.find(".cart_content--js");
        if (updatedCartDrawer.length) {
          $(".cart_content--js").html(updatedCartDrawer.html());
        } else {
          console.warn("Cart drawer section not found");
        }
      }

      $(".cd_checkoutbnt").removeClass("rendering");
      if (!SKELETON_DEBUG) {
        var elapsed = skeletonShownAt ? Date.now() - skeletonShownAt : 500;
        // If sections were pre-fetched (already in the response), content is
        // ready immediately — no need to hold the skeleton for 500ms.
        var delay = sectionsData ? 0 : Math.max(0, 500 - elapsed);
        skeletonShownAt = null;
        $(".cd_skeleton").addClass("cd_skeleton--hiding");
        setTimeout(function () {
          $(".cd_skeleton").removeClass(
            "cd_skeleton--visible cd_skeleton--hiding",
          );
        }, delay + 200);
      }

      cartPromise.then(function (cart) {
        // Update header cart count client-side
        $("[data-header-cart-count]")
          .attr("data-header-cart-count", cart.item_count)
          .text(cart.item_count);

        if (!skipGift && $giftData.length) {
          var threshold = parseInt($giftData.attr("data-threshold"));
          var giftId = parseInt($giftData.attr("data-id"));
          var giftItem = cart.items.find(function (item) {
            return item.variant_id === giftId;
          });
          var shouldHaveGift = cart.total_price >= threshold;

          if (shouldHaveGift && !giftItem) {
            fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: giftId,
                quantity: 1,
                sections: "cell_cart_drawer",
              }),
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (response) {
                window.refreshCartDrawer(true, response.sections);
                if (clickStart)
                  sendCartTiming(clickStart, apiStart, timingAction);
              });
          } else if (!shouldHaveGift && giftItem) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: giftItem.key,
                quantity: 0,
                sections: "cell_cart_drawer",
              }),
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (response) {
                window.refreshCartDrawer(true, response.sections);
                if (clickStart)
                  sendCartTiming(clickStart, apiStart, timingAction);
              });
          } else {
            if (clickStart) sendCartTiming(clickStart, apiStart, timingAction);
          }
        } else {
          if (clickStart) sendCartTiming(clickStart, apiStart, timingAction);
        }
      });
    });
  };

  $(document).on("click", ".ts-header__cart-toggle", function (evt) {
    evt.preventDefault();
    openCartDrawer();
  });

  $(document).on("click", ".gp_cta", function (evt) {
    evt.preventDefault();
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "gp_cta";
    var currentId = $(this).attr("data-id");
    var currentQty = parseFloat(
      $(this).closest(".gp_component").find(".gp_quantity-value").html(),
    );

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        window._cartApiStart = Date.now();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
            sections: "cell_cart_drawer",
          },
          dataType: "json",
          success: function (response) {
            refreshCartDrawer(false, response.sections);
            openCartDrawer(true);
          },
        });
      },
    });
  });

  $(document).on("submit", ".hm_offer-form", function (evt) {
    evt.preventDefault();
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "hm_offer_form";

    var currentId = $(this).find('input[name="id"]').attr("value");
    var newSellingPlanId = "";
    var currentQty = $(this).find(".hm_offer-quantity").attr("value");

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        window._cartApiStart = Date.now();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
            selling_plan: newSellingPlanId,
            sections: "cell_cart_drawer",
          },
          dataType: "json",
          success: function (response) {
            refreshCartDrawer(false, response.sections);
            openCartDrawer(true);
          },
        });
      },
    });
  });

  $(".custom_pp-btn_gp").click(function (e) {
    e.preventDefault();
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "custom_pp_btn";
    var currentId = $(this).attr("data-id");
    var currentQty = $(this).attr("data-qty");

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        window._cartApiStart = Date.now();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
            sections: "cell_cart_drawer",
          },
          dataType: "json",
          success: function (response) {
            refreshCartDrawer(false, response.sections);
            openCartDrawer(true);
          },
        });
      },
    });
  });

  $(".pdp_offer-card--btn_real").click(function (e) {
    e.preventDefault();
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "pdp_offer_card";
    var currentId = $(this)
      .closest(".hm_offer-form ")
      .find('input[name="id"]')
      .attr("value");
    var currentQty = 1;

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        window._cartApiStart = Date.now();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: currentQty,
            sections: "cell_cart_drawer",
          },
          dataType: "json",
          success: function (response) {
            refreshCartDrawer(false, response.sections);
            openCartDrawer(true);
          },
        });
      },
    });
  });

  $(document).on("click", ".cell_cart_upsell_btn", function (evt) {
    evt.preventDefault();
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "upsell_btn";

    var $btn = $(this);
    $btn.find(".upsell_btn_content").hide();
    $btn.find(".upsell_btn_loader").css("display", "block");

    var currentId = $btn.attr("data-id");
    var currentQty = 1;

    // Add to cart WITH line item property "OFFER"
    var data = {
      id: currentId,
      quantity: currentQty,
    };

    data.sections = "cell_cart_drawer";
    window._cartApiStart = Date.now();
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Failed to add to cart");
        return response.json();
      })
      .then(function (addedItem) {
        console.log("Upsell product added:", addedItem);
        window.refreshCartDrawer(false, addedItem.sections);

        $btn.find(".upsell_btn_content").show();
        $btn.find(".upsell_btn_loader").hide();
      })
      .catch(function (error) {
        console.error("Upsell error:", error);
        alert("Something went wrong. Please try again.");

        $btn.find(".upsell_btn_content").show();
        $btn.find(".upsell_btn_loader").hide();
      });
  });

  $(".product_complete-look-btn").on("click", function () {
    var $btn = $(this);
    $btn.find(".ts-product__loading").css("opacity", "1");

    var items = [];

    $(this)
      .closest(".product_complete-box")
      .find(".main-product_variants-line.mainOne")
      .each(function () {
        var currentId = $(this).attr("data-id");
        if (currentId) {
          items.push({
            id: Number(currentId),
            quantity: 1,
            properties: {
              OFFER: "Complete The Look",
            },
          });
        }
      });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: items }),
      dataType: "json",
      contentType: "application/json",
    })
      .done(function () {
        $.getJSON("/cart.js", function (cartData) {
          var updatedAttributes = cartData.attributes || {};
          updatedAttributes["complete_the_look"] = "true";

          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: JSON.stringify({ attributes: updatedAttributes }),
            dataType: "json",
            contentType: "application/json",
            success: function (updatedCart) {
              console.log("Cart updated with attribute:", updatedCart);
              window.refreshCartDrawer(false, null);
              window.openCartDrawer(true);
            },
            error: function (xhr) {
              console.error("Failed to update attributes:", xhr);
            },
            complete: function () {
              $btn.find(".ts-product__loading").css("opacity", "0");
            },
          });
        });
      })
      .fail(function (xhr) {
        console.error("Error adding items:", xhr);
        $btn.find(".ts-product__loading").css("opacity", "0");
      });
  });

  $(".col_pp_Atc_main__js").click(function () {
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "col_pp_atc";
    $(this).addClass("loading");
    var currentMode = $(".col_product-mode.active").attr("data");
    var currentId;
    var data;
    var sellingId = $(".col_product_variant.active").attr("data-selling-plan");
    if (currentMode == "sub") {
      currentId = $(".col_product_variant.active").attr("data-sub-id");
      data = {
        id: currentId,
        quantity: 1,
        selling_plan: sellingId,
      };
    } else {
      currentId = $(".col_product_variant.active").attr("data-id");
      data = {
        id: currentId,
        quantity: 1,
      };
    }

    console.log(data);

    data.sections = "cell_cart_drawer";
    window._cartApiStart = Date.now();
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (response) {
        openCartDrawer(true);
        refreshCartDrawer(false, response.sections);
        $(".col_pp_Atc_main__js").removeClass("loading");
      },
      error: function () {
        alert("Error adding item to the cart.");
        $(".col_pp_Atc_main__js").removeClass("loading");
      },
    });
  });

  $(".cd_outer").click(function (e) {
    if (!$(e.target).closest(".cd_inner").length) {
      closeCartDrawer();
    }
  });

  $(document).on("click", ".cd_close", function () {
    closeCartDrawer();
  });

  $(".product_complete-look-btn").on("click", function () {
    var $btn = $(this);
    $btn.find(".ts-product__loading").css("opacity", "1");
    var items = [];

    $(this)
      .closest(".product_complete-box")
      .find(".main-product_variants-line.mainOne")
      .each(function () {
        var currentId = $(this).attr("data-id");
        if (currentId) {
          items.push({
            id: Number(currentId),
            quantity: 1,
            properties: {
              OFFER: "Complete The Look",
            },
          });
        }
      });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: items }),
      dataType: "json",
      contentType: "application/json",
    })
      .done(function () {
        $.getJSON("/cart.js", function (cartData) {
          var updatedAttributes = cartData.attributes || {};
          updatedAttributes["complete_the_look"] = "true";

          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: JSON.stringify({ attributes: updatedAttributes }),
            dataType: "json",
            contentType: "application/json",
            success: function (updatedCart) {
              console.log("Cart updated with attribute:", updatedCart);
              window.refreshCartDrawer(false, null);
              window.openCartDrawer(true);
            },
            error: function (xhr) {
              console.error("Failed to update attributes:", xhr);
            },
            complete: function () {
              $btn.find(".ts-product__loading").css("opacity", "0");
            },
          });
        });
      })
      .fail(function (xhr) {
        console.error("Error adding items:", xhr);
        $btn.find(".ts-product__loading").css("opacity", "0");
      });
  });

  $(document).on("click", ".cd_item-plus", function () {
    window._cartTimingStart = Date.now();
    window._cartApiStart = Date.now();
    window._cartTimingAction = "cart_qty_plus";
    $(this).closest(".cd_item").addClass("loading");
    var $item = $(this).closest(".cd_item");
    var currentVal = parseFloat($item.find(".cd_item-val").html());
    currentVal++;
    var lineKey = $item.attr("data-key");

    var data = {
      id: lineKey,
      quantity: currentVal,
    };

    data.sections = "cell_cart_drawer";
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function (response) {
        refreshCartDrawer(false, response.sections);
      },
    });
  });

  $(document).on("click", ".cd_item-remove", function () {
    window._cartTimingStart = Date.now();
    window._cartApiStart = Date.now();
    window._cartTimingAction = "cart_remove";
    var $item = $(this).closest(".cd_item");
    $item.addClass("loading");
    var lineKey = $item.attr("data-key");

    var data = {
      id: lineKey,
      quantity: 0,
    };

    data.sections = "cell_cart_drawer";
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function (response) {
        refreshCartDrawer(false, response.sections);
      },
    });
  });

  $(document).on("click", ".cd_item-minus", function () {
    window._cartTimingStart = Date.now();
    window._cartApiStart = Date.now();
    window._cartTimingAction = "cart_qty_minus";
    var $item = $(this).closest(".cd_item");
    $item.addClass("loading");
    var currentVal = parseFloat($item.find(".cd_item-val").html());
    currentVal--;
    var lineKey = $item.attr("data-key");

    var data = {
      id: lineKey,
      quantity: currentVal,
    };

    data.sections = "cell_cart_drawer";
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function (response) {
        refreshCartDrawer(false, response.sections);
      },
    });
  });

  $(document).on("click", ".cell_upsell-swatch", function () {
    $(this)
      .closest(".pp_upsell_item")
      .find(".cell_upsell-swatch")
      .removeClass("active");
    $(this).addClass("active");

    var currentId = $(this).attr("data-id");
    var newSrc = $('.upsellPrJs_data[data-id="' + currentId + '"]').attr(
      "data-src",
    );
    $(this)
      .closest(".pp_upsell_item")
      .find(".upsellMainImg")
      .attr("src", newSrc);

    $(this)
      .closest(".pp_upsell_item")
      .find(".cell_cart_upsell_btn")
      .attr("data-id", currentId);
  });

  $(document).on("click", "[id^='TSProductSubmit']", function () {
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "pdp_" + (this.id || "TSProductSubmit");
  });

  $(document).on("click", ".main-productBundleAtc", function () {
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "pdp_BundleAtc";
  });

  $(document).on("click", ".product_sticky-atc-btn", function () {
    window._cartTimingStart = Date.now();
    window._cartTimingAction = "pdp_StickyAtc";
  });

  $("#TSProductSubmitQuantityCart").click(function (evt) {
    evt.preventDefault();

    $(".ts-product__button").find(".ts-product__loading").css("opacity", "1");
    setTimeout(function () {
      $(".ts-product__button").find(".ts-product__loading").css("opacity", "0");
    }, 2000);

    var items = [];

    var currentId = $(".simple-product_shade.active").attr("data-id");
    var currentQty = parseFloat(
      $(".product_main-atc-qty-box").find(".psa_qty_value").html(),
    );

    var selling_plan = "";
    if ($('.main_product-sub-selector-line[data="sub"]').hasClass("active")) {
      selling_plan = $('.main_product-sub-selector-line[data="sub"]').attr(
        "data-id",
      );
    }

    items.push({
      id: currentId,
      quantity: currentQty,
      selling_plan: selling_plan,
    });

    window._cartApiStart = Date.now();
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items, sections: "cell_cart_drawer" }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to add to cart");
        return res.json();
      })
      .then((data) => {
        window.refreshCartDrawer(false, data.sections);
        window.openCartDrawer(true);
      })
      .catch((err) => console.error("Error:", err));
  });
});
